import Like from '../assets/svg/Like.svg';
import Love from '../assets/svg/Love.svg';
import Celebration from '../assets/svg/Celebration.svg';
import Cheer from '../assets/svg/Cheer.svg';
import Excellent from '../assets/svg/Excellent.svg';

export const customEmojis = [
    { unified: "1f44d", name: "like", image: Like },
    { unified: "2764-fe0f", name: "heart", image: Love },
    { unified: "1f389", name: "celebration", image: Celebration },
    { unified: "1f31f", name: "excellent", image: Excellent },
    { unified: "1f973", name: "cheer", image: Cheer },
]